var _defs, _path, _path2, _path3, _path4, _circle, _path5, _path6, _circle2, _path7, _circle3, _path8, _circle4, _circle5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg10035IconServiceAppServices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b70acf0a-34b4-4bdf-9024-7496043ff915",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "e2cf8746-c9a8-4eee-86c2-4951983c6032",
    cx: 13428.81,
    cy: 3518.86,
    r: 56.67,
    gradientTransform: "translate(-2005.33 -518.83) scale(0.15)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#5ea0ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0078d4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bdd213dd-d313-473c-8ff4-0133fd3a9033",
    x1: 4.4,
    y1: 11.48,
    x2: 4.37,
    y2: 7.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fcfcfc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "afcc63c5-3649-4476-a742-bcb53a569f3c",
    x1: 10.13,
    y1: 15.45,
    x2: 10.13,
    y2: 11.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fcfcfc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bd873f0b-9954-4aa5-a3df-9f4c64e8729d",
    x1: 14.18,
    y1: 11.15,
    x2: 14.18,
    y2: 7.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fcfcfc"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-web-41") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ee75dd06-1aca-4f76-9d11-d05a284020ad",
    d: "M14.21,15.72A8.5,8.5,0,0,1,3.79,2.28l.09-.06a8.5,8.5,0,0,1,10.33,13.5",
    fill: "url(#e2cf8746-c9a8-4eee-86c2-4951983c6032)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.69,7.23A13,13,0,0,1,15.6,3.65a8.47,8.47,0,0,0-1.49-1.44,14.34,14.34,0,0,0-4.69,1.1A12.54,12.54,0,0,0,5.34,6.13,2.76,2.76,0,0,1,6.69,7.23Z",
    fill: "#fff",
    opacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.48,10.65a17.86,17.86,0,0,0-.83,2.62,7.82,7.82,0,0,0,.62.92c.18.23.35.44.55.65A17.94,17.94,0,0,1,3.9,11.37,2.76,2.76,0,0,1,2.48,10.65Z",
    fill: "#fff",
    opacity: 0.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.46,6.11a12,12,0,0,1-.69-2.94,8.15,8.15,0,0,0-1.1,1.45A12.69,12.69,0,0,0,2.24,7,2.69,2.69,0,0,1,3.46,6.11Z",
    fill: "#f2f2f2",
    opacity: 0.55
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4.38,
    cy: 8.68,
    r: 2.73,
    fill: "url(#bdd213dd-d313-473c-8ff4-0133fd3a9033)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.36,13.67A1.77,1.77,0,0,1,8.9,12.4a11.88,11.88,0,0,1-2.53-1.86,2.74,2.74,0,0,1-1.49.83,13.1,13.1,0,0,0,1.45,1.28A12.12,12.12,0,0,0,8.38,13.9,1.79,1.79,0,0,1,8.36,13.67Z",
    fill: "#f2f2f2",
    opacity: 0.55
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.66,13.88a12,12,0,0,1-2.76-.32.41.41,0,0,1,0,.11,1.75,1.75,0,0,1-.51,1.24,13.69,13.69,0,0,0,3.42.24A8.21,8.21,0,0,0,16,13.81,11.5,11.5,0,0,1,14.66,13.88Z",
    fill: "#f2f2f2",
    opacity: 0.55
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.13,
    cy: 13.67,
    r: 1.78,
    fill: "url(#afcc63c5-3649-4476-a742-bcb53a569f3c)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.32,8.93a1.83,1.83,0,0,1,.61-1A25.5,25.5,0,0,1,8.47,3.79a16.91,16.91,0,0,1-2-2.92,7.64,7.64,0,0,0-1.09.42A18.14,18.14,0,0,0,7.53,4.47,26.44,26.44,0,0,0,12.32,8.93Z",
    fill: "#f2f2f2",
    opacity: 0.7
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.18,
    cy: 9.27,
    r: 1.89,
    fill: "url(#bd873f0b-9954-4aa5-a3df-9f4c64e8729d)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.35,10.54,17,10.37l0,0-.3-.16-.06,0L16.38,10l-.07,0L16,9.8a1.76,1.76,0,0,1-.64.92c.12.08.25.15.38.22l.08.05.35.19,0,0,.86.45h0a8.63,8.63,0,0,0,.29-1.11Z",
    fill: "#f2f2f2",
    opacity: 0.55
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.38,
    cy: 8.68,
    r: 2.73,
    fill: "url(#bdd213dd-d313-473c-8ff4-0133fd3a9033)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.13,
    cy: 13.67,
    r: 1.78,
    fill: "url(#afcc63c5-3649-4476-a742-bcb53a569f3c)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg10035IconServiceAppServices);
export default __webpack_public_path__ + "static/media/10035-icon-service-App-Services.bdfe9ddde8ba57b2f678990699a4c4b0.svg";
export { ForwardRef as ReactComponent };